import firebase from "firebase/compat/app";
import "firebase/compat/functions";
import "firebase/compat/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCP8Y8OOa47u37rXkK8kiYGoTY0Ko8KtgA",
  authDomain: "removecrp.firebaseapp.com",
  projectId: "removecrp",
  storageBucket: "removecrp.appspot.com",
  messagingSenderId: "837063774990",
  appId: "1:837063774990:web:9139b6a8908fbb8c19fd5f",
  measurementId: "G-4Q1MWPSP97",
};

// Initialize Firebase
export const app = firebase.initializeApp(firebaseConfig);
export const functions = firebase.functions();
export const storage = firebase.storage();
